export enum CertificateTaskStatus {
  Pending = 'Pending',
  Completed = 'Completed',
}

export interface ICertificateTaskSite {
  bpn: string;
  name: string | null;
}

export interface ICertificateTask {
  id: number;
  company: {
    companyName: string | null;
    companyBpn: string;
  };
  certificateType: string;
  sitesRequested: ICertificateTaskSite[];
  dateReceived: string;
  status: CertificateTaskStatus;
}
